import React from "react";
import { CheckField as CheckFieldInterface } from "~/tenant/types";
import FormControl from "@pency/components/form/FormControl";
import RadioGroup, { RadioRow } from "@pency/components/inputs/Radio";
import { useTranslation, usePrice } from "~/i18n/hooks";

const DELIVERY_METHOD_FIELD_ID = "default_delivery_mode";

interface Props {
  value: string;
  field: CheckFieldInterface;
  onChange: (value: string) => void;
}

const CheckField: React.FC<Props> = ({ value, field, onChange }) => {
  const t = useTranslation();
  const p = usePrice();
  const getCost = (option) => {
    return ["Custo fixo", "Costo fijo", "Fixed cost"].includes(option.selected)
      ? p(field.cost)
      : "";
  };
  const getValue = (option) =>
    field.id === DELIVERY_METHOD_FIELD_ID
      ? option.value ?? option.id
      : t(option.title);
  const selectedValue = value;

  return (
    <FormControl
      help={field.note}
      isRequired={field.required}
      label={t(field.title)}
      width="100%"
    >
      <RadioGroup
        value={selectedValue}
        onChange={(event) => onChange(event.target.value)}
      >
        {field.options.map((option) => {
          const title = t(option.title);
          return (
            <RadioRow key={option.id} note={getCost(option)} value={getValue(option)}>
              {title}
            </RadioRow>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default CheckField;
